const doc = [({"en":({"js":({"users":({"settings":({"settings":"Settings", "user_information":"User information:"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;